type Props = {
  activeCount: number;
  onClick: () => void;
  ariaExpanded?: boolean;
};

export function FilterButton({ activeCount, onClick, ariaExpanded }: Props) {
  return (
    <button
      type="button"
      className={`poca-filter-btn${activeCount > 0 ? " poca-filter-btn--active" : ""}`}
      onClick={onClick}
      aria-label={
        activeCount > 0
          ? `Filters, ${activeCount} active`
          : "Open filters"
      }
      aria-expanded={ariaExpanded}
    >
      <svg
        className="poca-filter-btn__icon"
        viewBox="0 0 20 20"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M3 5h14M5.5 10h9M8.5 15h5"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <circle cx="7" cy="5" r="1.6" fill="currentColor" />
        <circle cx="13" cy="10" r="1.6" fill="currentColor" />
        <circle cx="11" cy="15" r="1.6" fill="currentColor" />
      </svg>
      {activeCount > 0 && (
        <span className="poca-filter-btn__badge" aria-hidden="true">
          {activeCount}
        </span>
      )}
    </button>
  );
}
